import * as React from 'react';

const Rule = ({ classNames = 'bg-indigo-500 dark:bg-indigo-200' }) => (
  <div className={`w-12 h-1 mt-2 mb-4 rounded ${classNames}`} />
);

export default Rule;
